import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import PageTitle from "components/PageTitle";
import { Grid } from "components/Containers";
import {
  RolesList,
  RolesFilters,
  RolePipeline,
  KEYS,
  ROLE_AND_SKILLS_COLUMNS,
  COLUMN_DATA,
} from "components/Missions/Roles";
import { formatDate } from "utils";
import { useParamFunctions } from "hooks";
import { MISSION_ROLES_COLUMNS } from "constants/index";
/**
 * Role Page
 */
const Roles = () => {
  const intl = useIntl();
  const { paramParse } = useParamFunctions();
  const parsedFilters = paramParse(KEYS.filters);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Roles.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle subtitle={<FormattedMessage id="Missions.Roles.H1" />} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <RolesFilters />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <RolesList
            isCardView={false}
            selectable={false}
            filters={parsedFilters}
            columns={COLUMNS}
            includeProfilesCount
          />
        </Grid.col>
      </Grid>
    </>
  );
};

const ROLE_LIST_COLUMNS = [MISSION_ROLES_COLUMNS.matchingProfiles];

const COLUMNS = [
  {
    label: <FormattedMessage id="Missions.Roles.TableCreatedAt" />,
    cell: (row) => (row?.createdAt ? formatDate(row.createdAt) : <FormattedMessage id="Global.EmDash" />),
    width: 120,
  },
  ...ROLE_AND_SKILLS_COLUMNS,
  ...ROLE_LIST_COLUMNS,
  ...COLUMN_DATA,
  {
    label: <FormattedMessage id="Missions.Roles.TablePipeline" />,
    width: 200,
    cell: (row) => (
      <RolePipeline
        data={[
          row?.pendingCandidatesCount,
          row?.applicantsCount,
          row?.shortlistedCandidatesCount,
          row?.interviewedCandidatesCount,
          row?.selectedCandidatesCount,
        ]}
      />
    ),
  },
];

export default Roles;
